<template>
  <div class="checkbox">
    <label :for="name" class="checkbox-label">
      <div :class="{ checkbox__checkmark: true, checked: value }">
        <img
          class="checkbox__checkmark-img"
          src="@/assets/icons/Checkmark.svg"
          alt=""
        />
      </div>
      <Input
        :id="name"
        :name="name"
        class="checkbox-input"
        type="checkbox"
        :checked="value"
        :disabled="disabled"
      />
      <span class="checkbox-title" v-if="title">{{ title }}</span>
    </label>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Checkbox',
  props: ['title', 'name', 'value', 'disabled']
})
export default class CheckboxComponent extends Vue {}
</script>

<style lang="scss" scoped>
.checkbox {
  position: relative;
  height: 16px;
  min-width: 16px;
  width: max-content;
  .checkbox-input {
    position: absolute;
    appearance: none;
  }
  .checkbox-label {
    display: flex;
    align-items: center;
    height: 100%;
    width: auto;
    font-size: $fourteenSize;
    line-height: $twentySize;
    cursor: pointer;
    .checkbox__checkmark {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      display: block;
      width: 14px;
      height: 14px;
      border-radius: 3px;
      border: 1px solid $checkbox-border;
      background-color: $white;
      transition: background 0.1s linear, border 0.1s linear;
      z-index: 0;
      &.checked {
        background-color: $main-green;
        border: 1px solid $main-green;
      }
      .checkbox__checkmark-img {
        position: absolute;
        top: 3px;
        left: 2px;
        width: 10px;
        height: 8px;
        z-index: 2;
        opacity: 0;
        background-color: $main-green;
        transition: opacity 0.1s linear;
      }
      &.checked .checkbox__checkmark-img {
        opacity: 1;
      }
    }
    .checkbox-title {
      display: block;
      max-width: 510px;
      margin-left: 26px;
    }
  }
}
</style>

<style lang="scss">
.checkbox-label {
  .formkit-outer {
    display: none;
  }
}
</style>
